import type { NovaMeta } from '@/types/dashboards';

/** A meta das sopradoras (`/api/dashboards/equiplex/metas/`): erro do backend e valores da tela. */

export interface ErrosMeta {
  geral: string;
  campos: Partial<Record<keyof NovaMeta, string>>;
}

type CorpoErro = { error?: { message?: string; errors?: Record<string, string[] | string> } };

const CAMPOS: readonly (keyof NovaMeta)[] = ['maquina', 'unidades_dia', 'vigente_desde', 'observacao'];

const primeira = (v: string[] | string): string => (Array.isArray(v) ? (v[0] ?? '') : v);

/** `{"error": {"message", "errors": {campo: [msg]}}}` em mensagem geral + mensagem por campo. */
export function errosDaMeta(erro: unknown): ErrosMeta {
  const corpo = (erro as { response?: { data?: CorpoErro } })?.response?.data?.error;
  const campos: ErrosMeta['campos'] = {};
  let semCampo = '';
  for (const [campo, msg] of Object.entries(corpo?.errors ?? {})) {
    if ((CAMPOS as readonly string[]).includes(campo)) campos[campo as keyof NovaMeta] = primeira(msg);
    else semCampo = semCampo || primeira(msg);
  }
  if (Object.keys(campos).length > 0) return { geral: semCampo || 'Confira os campos destacados.', campos };
  return { geral: semCampo || corpo?.message || 'Não foi possível salvar a meta.', campos };
}

/** Hoje no fuso de quem está na tela, em AAAA-MM-DD (o padrão de "vale a partir de"). */
export function hojeIso(agora: Date = new Date()): string {
  const mes = String(agora.getMonth() + 1).padStart(2, '0');
  const dia = String(agora.getDate()).padStart(2, '0');
  return `${agora.getFullYear()}-${mes}-${dia}`;
}

/** "45.000" ou "45000" digitado → 45000; vazio ou inválido → `null`. Só inteiro: é unidade de frasco. */
export function unidadesDoTexto(texto: string): number | null {
  const limpo = texto.replace(/\./g, '').replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d+)?$/.test(limpo)) return null;
  return Math.round(Number(limpo));
}
